import styled from "styled-components";

export const ObraAvatar = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 10px !important;
  width: 100%;
  padding-left: 2px;
  padding-bottom: 10px;
  > span,
  > button {
    margin-right: 4px;
  }

  .buttomUser {
    background-color: ${({ theme }) => theme.colors.secondary.secondary};
    color: ${({ theme }) => theme.colors.secondary.onSecondaryVariant};
    border: ${({ theme }) => theme.colors.secondary.secondaryOutline};
    min-width: 28px !important;
    width: 28px;
    height: 28px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    
    font-size: 18px;
    font-weight: bold;

    &:hover {
      background-color: ${({ theme }) => `color-mix(in srgb, ${theme.colors.secondary.onSecondaryHover}, ${theme.colors.secondary.secondary})`} !important;
      color: ${({ theme }) => theme.colors.secondary.onSecondary} !important;
      border-color: transparent !important;
    }
  }

  .buttomListUser {
    background-color: ${({ theme }) => `color-mix(in srgb, ${theme.colors.primary.primaryContainer}, ${theme.colors.primary.primary})`} !important;
    color: ${({ theme }) => theme.colors.primary.onPrimary} !important;
    border: ${({ theme }) => theme.colors.secondary.secondaryOutline};
    min-width: 28px !important;
    width: 28px;
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: default !important;
  }
  .buttomListUser {
    width: 28px !important;
    height: 28px !important;
    min-width: 28px !important;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    background-color: ${({ theme }) => `color-mix(in srgb, ${theme.colors.primary.primaryContainer}, ${theme.colors.primary.primary})`} !important;
    color: ${({ theme }) => theme.colors.primary.onPrimary} !important;
    margin-right: 4px !important;
    margin-left: 4px !important;
    cursor: default !important;
  }
`;

export const ListSharedUsers = styled.div`
  display: flex;
  flex-direction: column;
  
  label {
    padding: 1px 3px;
  }
`;
